export const approvalType = {
  2: { name: "Premium Overdraft" },
  3: { name: "Cog Consumer Custom Plan" },
  4: { name: "Cog Business Custom Plan" },
  7: { name: "Euro Consumer Custom Plan" },
  8: { name: "Euro Business Custom Plan" },
};

export const stocksCurrencies = ["CB25CO75","CB50CO50","CB75CO25","CBC100","COG100"]